<template>
	<div>
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form role="form" class="mt-4">
				<b-row>
					<b-col md="8" cols="12">
						<b-form-group label="Account Type">
							<el-select v-model="form.account_type" placeholder="Select">
								<el-option v-for="item in accountTypeList" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12">
						<b-form-group label="Bank Name">
							<el-select v-model="form.bank_id" placeholder="Select">
								<el-option v-for="item in tables.banks" :key="item.bank_id" :label="item.name" :value="item.bank_id">
								</el-option>
							</el-select>
						</b-form-group>
					</b-col>

					<b-col md="8" cols="12">
						<b-form-group label="Account Number">
							<ValidationProvider v-slot="{ errors }" :rules="{ number_only: true }" :vid="'number_only'">
								<b-form-input v-model="form.disbursement_acc_no" type="text" placeholder="Enter Account Number"
									@keydown="preventNonNumericInput">
								</b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>

					<b-col cols="8">
						<b-button block variant="primary" class="w-50" @click.prevent="submit" :disabled="invalid">Save</b-button>
					</b-col>
				</b-row>
			</b-form>
		</ValidationObserver>
	</div>
</template>
<script>
import { Select, Option } from 'element-ui';
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';
import { useCustomerStore } from '@/stores/customerStore';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { preventNonNumericInput } from '@/assets/js/formValidations.js';
import '@/assets/js/formValidations.js';

export default {
	name: 'bank-details-form',
	components: {
		ValidationObserver,
		ValidationProvider,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			form: {
			account_no: '',
			customer_id: '',
			bank_id: '',
			disbursement_acc_no: '',
			account_type: '',
			mothers_maiden_name: '',
			},
			accountTypeList: [
			{
				value: 'Saving',
				label: 'Saving Account'
			},
			{
				value: 'Loan',
				label: 'Loan Account'
			},
			],
			tables: {
				banks: []
			}
		}
	},
	computed: {
		...mapState(useCustomerStore,['activeCustomer']),
	},
	created() {
		this.getBanks();
		this.form = this.activeCustomer.bank || {};
	},
	methods: {
		...mapActions(useCommonStore,['getTables']),
		...mapActions(useCustomerStore,['addBankDetail','updateBankDetail','getCustomerIm2u']),
		preventNonNumericInput,
		getBanks() {
			this.getTables('banks').then(resp => {
				this.tables.banks = resp.banks;
			});
		},
		submit() {
			this.activeCustomer.bank ? this.update(this.activeCustomer.bank.customer_bank_id) : this.create()
		},
		update(id) {
			this.updateBankDetail(id, this.form).then((resp) => {
			_gNotif.notifySuccess('<b>Bank Details: ' + this.activeCustomer.name + '</b> - Successfully Updated.');
			this.getCustomerIm2u(this.activeCustomer.customer_id);
			}).catch((error) => {
			_gNotif.errorFunction(error);
			});
		},
		create() {
			this.addBankDetail(this.form).then((resp) => {
			_gNotif.notifySuccess('<b>Bank Details: ' + this.activeCustomer.name + '</b> - Successfully Created.');
			this.getCustomerIm2u(this.activeCustomer.customer_id);
			}).catch((error) => {
				_gNotif.errorFunction(error);
			});
		},
	}
}
</script>